import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import type { Cliente } from '../api';
import { buscarCliente } from './api';

/** Lo mínimo para buscar una ficha: los tres datos de su clave natural. */
export interface ClaveDeFicha {
  tenantId: number;
  docTipo: Cliente['docTipo'];
  docNro: number;
}

/**
 * La ficha ya cargada de un receptor, para no volver a tipear nombre y
 * domicilio de un cliente al que se le factura seguido. `undefined` en `clave`
 * apaga la consulta: no se pregunta por un documento a medio escribir.
 *
 * Sin reintentos: es una ayuda para completar campos, no algo de lo que dependa
 * la emisión. Si falla, la persona los escribe a mano.
 */
export function useFichaDelReceptor(clave: ClaveDeFicha | undefined): UseQueryResult<Cliente | null, Error> {
  return useQuery({
    queryKey: ['clientes', clave?.tenantId, clave?.docTipo, clave?.docNro],
    queryFn: () => buscarCliente(clave as ClaveDeFicha),
    enabled: clave !== undefined,
    retry: false,
    staleTime: 60_000,
  });
}
